import { Application, Container } from "pixi.js";

export interface StageOptions {
  width: number;
  height: number;
  backgroundColor?: number;
}

export class GameStage {
  private app: Application;
  private root: Container;
  private gameLayers: Map<string, Container> = new Map();

  constructor(app: Application, options: StageOptions) {
    this.app = app;
    this.root = new Container();
    this.root.width = options.width;
    this.root.height = options.height;

    this.setupLayers();
    this.app.stage.addChild(this.root);
  }

  private setupLayers(): void {
    const layers = [
      "background",
      "particles",
      "slots",
      "bottles",
      "ui",
      "overlays",
      "debug"
    ];

    for (const layerName of layers) {
      const layer = new Container();
      layer.name = layerName;
      this.root.addChild(layer);
      this.gameLayers.set(layerName, layer);
    }
  }

  getLayer(name: string): Container {
    const layer = this.gameLayers.get(name);
    if (!layer) {
      throw new Error(`Layer "${name}" not found`);
    }
    return layer;
  }

  getRoot(): Container {
    return this.root;
  }

  resize(width: number, height: number): void {
    this.root.width = width;
    this.root.height = height;
  }

  destroy(): void {
    this.app.stage.removeChild(this.root);
    this.root.destroy();
    this.gameLayers.clear();
  }
}

export async function createStage(app: Application, options?: Partial<StageOptions>): Promise<GameStage> {
  const defaultOptions: StageOptions = {
    width: app.screen.width,
    height: app.screen.height,
    backgroundColor: 0x1a1a2e,
    ...options
  };

  return new GameStage(app, defaultOptions);
}
